/* eslint-disable-next-line */
import http from './index';

/**
 * C++诊断 获取诊断成绩
 * @param {string} bundleId 题组ID
 */
export function getDiagnosisResult(params) {
  return http({
    // baseURL: 'http://localhost:8080',
    url: 'diagnostic/rest/getResult',
    method: 'GET',
    params,
  });
}


/**
 * C++诊断 交卷
 * @param {string} bundleId 题组ID
 */
 export function submitDiagnosis(params) {
  return http({
    // baseURL: 'http://localhost:8080',
    url: 'diagnostic/rest/submit',
    method: 'POST',
    data: params,
  });
}